import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import PropTypes from "prop-types";
const openAndCloseOption = [
  { id: "1", label: "Open", value: 1 },
  { id: "0", label: "Close", value: 0 },
];

const CompanyOpenCloseForm = ({ name, placeholder, timingName }) => {
  const openTimeName = `${timingName}OpenTime`;
  const closeTimeName = `${timingName}CloseTime`;
  const openPlaceHolder = `${placeholder} Open Time`;
  const closePlaceHolder = `${placeholder} Close Time`;

  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="form-row row">
      <div className="col-md-4 mb-3">
        <Input
          name={name}
          type="commonSelect"
          placeholder={placeholder}
          className={`form-control ${errors[name] ? "is-invalid" : ""}`}
          label={placeholder}
          labelClassName="form-label"
          optionData={openAndCloseOption}
          required={true}
          requiredMessage={placeholder}
          onChange={(selectedOption) => {
            setValue(name, selectedOption);
            trigger(name);
          }}
          defaultValue={watch(name)}
        />
      </div>

      <div className="col-md-4 mb-3">
        <Input
          name={openTimeName}
          type="time"
          placeholder={openPlaceHolder}
          className={`form-control ${errors[openTimeName] ? "is-invalid" : ""}`}
          label={openPlaceHolder}
          labelClassName="form-label"
          optionData={openAndCloseOption}
          required={true}
          requiredMessage={openPlaceHolder}
          defaultValue={watch(openTimeName)}
        />
      </div>

      <div className="col-md-4 mb-3">
        <Input
          name={closeTimeName}
          type="time"
          placeholder={closePlaceHolder}
          className={`form-control ${errors[closeTimeName] ? "is-invalid" : ""}`}
          label={closePlaceHolder}
          labelClassName="form-label"
          optionData={openAndCloseOption}
          required={true}
          requiredMessage={closePlaceHolder}
          defaultValue={watch(closeTimeName)}
        />
      </div>

      {/*      

      <div className="col-md-4 mb-3">
        <label>
          {placeholder} Close Time<span className="asterisk">*</span>
        </label>
        <input
          {...register("mondayCloseTime")}
          type="time"
          className={`form-control ${
            errors.mondayCloseTime ? "is-invalid" : ""
          }`}
        />
        {errors.mondayCloseTime && (
          <div className="invalid-feedback">
            {errors.mondayCloseTime?.message || "Invalid input"}
          </div>
        )}
      </div> */}
    </div>
  );
};

CompanyOpenCloseForm.propTypes = {
    name : PropTypes.string.isRequired,
    placeholder : PropTypes.string.isRequired,
    timingName : PropTypes.string.isRequired
}

export default CompanyOpenCloseForm;
